import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-formations-catalog',
    template: `
    <app-tool-loader [isLoading]="false" positionUnset="true">
      <app-formations-cement-catalog [catalogType]="'formation'" [componentId]="componentId"></app-formations-cement-catalog>
    </app-tool-loader>
  `,
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormationsCatalogComponent {
  @Input() public componentId!: string;
}
